import { render, staticRenderFns } from "./pointModal.vue?vue&type=template&id=2f30d7a3&scoped=true&"
import script from "./pointModal.vue?vue&type=script&lang=js&"
export * from "./pointModal.vue?vue&type=script&lang=js&"
import style0 from "./pointModal.vue?vue&type=style&index=0&id=2f30d7a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f30d7a3",
  null
  
)

export default component.exports